import { DynamicImage } from '@common/ui/DynamicImage';

import styles from './ChatProfilePicture.module.scss';

export interface ChatProfilePictureProps {
  image: string;
  online?: boolean;
}

export const ChatProfilePicture = ({
  image,
  online,
}: ChatProfilePictureProps) => {
  const isOnline = online ?? false;

  return (
    <div className={styles.chatProfilePicture}>
      <DynamicImage
        src={image}
        loading="lazy"
        alt="profile-avatar"
        testId="chat-profile-picture-avatar"
      />
      <div
        className={styles.online}
        data-online={isOnline}
        data-test-id={
          isOnline
            ? 'chat-profile-picture-online-indicator'
            : 'chat-profile-picture-offline-indicator'
        }
      />
    </div>
  );
};
